import { Navigate } from 'react-router-dom'
import { useCurrentUser } from '../../hooks/useCurrentUser'
import GlobalDbStats from '../../components/admin/GlobalDbStats'
import GlobalDbSavings from '../../components/admin/GlobalDbSavings'
import GlobalDbActivity from '../../components/admin/GlobalDbActivity'
import GlobalDbErrors from '../../components/admin/GlobalDbErrors'
import GlobalDbDiscovery from '../../components/admin/GlobalDbDiscovery'
import GlobalDbRefreshQueue from '../../components/admin/GlobalDbRefreshQueue'

export default function GlobalDatabase() {
  const { isAdmin, loading: userLoading } = useCurrentUser()

  if (userLoading) return <div className="p-8 text-[#8B8FA7]">Chargement...</div>
  if (!isAdmin) return <Navigate to="/projects" replace />

  return (
    <div className="p-6 space-y-6 max-w-[1400px] mx-auto">
      <div>
        <h1 className="text-2xl font-bold text-[#1B2559]">Global Keyword Database</h1>
        <p className="text-[#8B8FA7] mt-1">BDD propriétaire de mots-clés — cache mutualisé DataForSEO</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <GlobalDbStats />
        <GlobalDbSavings />
      </div>

      <GlobalDbDiscovery />

      <GlobalDbRefreshQueue />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <GlobalDbActivity />
        <GlobalDbErrors />
      </div>
    </div>
  )
}
